import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { stringToBoolean } from 'src/app/shared/utils/string-to-boolean.util';

@Injectable({
  providedIn: 'root'
})
export class StyleguideGuard  {
  constructor(private router: Router) {}

  public canLoad() {
    if (stringToBoolean(environment.debug)) {
      return true;
    }

    this.router.navigate(['']);

    return false;
  }
}
